function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECECEC",
    style: {
      fill: "#ECECEC",
      fill: "color(display-p3 0.9255 0.9255 0.9255)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9167 30.1667H17.3334C12.6667 30.1667 10.3334 29 10.3334 23.1667V17.3333C10.3334 12.6667 12.6667 10.3333 17.3334 10.3333H26.6667C31.3334 10.3333 33.6667 12.6667 33.6667 17.3333V23.1667C33.6667 27.8333 31.3334 30.1667 26.6667 30.1667H26.0834C25.7217 30.1667 25.3717 30.3417 25.15 30.6333L23.4 32.9667C22.63 33.9933 21.37 33.9933 20.6 32.9667L18.85 30.6333C18.6634 30.3767 18.2317 30.1667 17.9167 30.1667Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1666 17.3333H27.8333",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1666 23.1667H23.1666",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIcon);
export default __webpack_public_path__ + "static/media/messagesIcon.39ccace1e7a79563d8714daf71247c05.svg";
export { ForwardRef as ReactComponent };